const EXPLICIT_KEY = 'minha-obra-mode-explicit'
const AUTO_HINT_KEY = 'minha-obra-mode-auto-hint'
const MODO_HINT_KEY = 'minha-obra-modo-hint'

export function isModeExplicit(): boolean {
  return localStorage.getItem(EXPLICIT_KEY) === '1'
}

export function markModeExplicit(): void {
  localStorage.setItem(EXPLICIT_KEY, '1')
}

export function isAutoModeHintSeen(): boolean {
  return localStorage.getItem(AUTO_HINT_KEY) === '1'
}

export function markAutoModeHintSeen(): void {
  localStorage.setItem(AUTO_HINT_KEY, '1')
}

export function isModoHintSeen(): boolean {
  return localStorage.getItem(MODO_HINT_KEY) === '1'
}

export function markModoHintSeen(): void {
  localStorage.setItem(MODO_HINT_KEY, '1')
}
